export default {"src":"/_next/static/media/WhoWeAre_003A.8749a3a7.JPG","height":690,"width":1920};